module.exports = __webpack_public_path__ + "img/retirementquote.4ddbde69.png";